export default function clearString(value) {
  return value.replace(/[.\-/() ]/g, '');
}
